// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet producten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfSUREbusinessCCSReadingOdbcGetMaatschappijenByCssNummersMaatschappijDto } from '../model/collectionResultOfSUREbusinessCCSReadingOdbcGetMaatschappijenByCssNummersMaatschappijDto';

import type { MaatschappijenGetMaatschappijenByCcsNummersParams } from '../model/maatschappijenGetMaatschappijenByCcsNummersParams';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.MaatschappijenInzien</li></ul>
 * @summary Haal css maatschappijen op aan de hand van de meegegeven ccs nummers.
 */
export const maatschappijenGetMaatschappijenByCcsNummers = (
  params?: MaybeRef<MaatschappijenGetMaatschappijenByCcsNummersParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfSUREbusinessCCSReadingOdbcGetMaatschappijenByCssNummersMaatschappijDto>(
    {
      url: `/api/public/v1/maatschappijen/ccs-maatschappijen`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getMaatschappijenGetMaatschappijenByCcsNummersQueryKey = (
  params?: MaybeRef<MaatschappijenGetMaatschappijenByCcsNummersParams>,
) => {
  return [
    'api',
    'public',
    'v1',
    'maatschappijen',
    'ccs-maatschappijen',
    ...(params ? [params] : []),
  ] as const;
};

export const getMaatschappijenGetMaatschappijenByCcsNummersQueryOptions = <
  TData = Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<MaatschappijenGetMaatschappijenByCcsNummersParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatschappijenGetMaatschappijenByCcsNummersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>
  > = ({ signal }) => maatschappijenGetMaatschappijenByCcsNummers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>,
    TError,
    TData
  >;
};

export type MaatschappijenGetMaatschappijenByCcsNummersQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>
>;
export type MaatschappijenGetMaatschappijenByCcsNummersQueryError = ErrorType<void>;

/**
 * @summary Haal css maatschappijen op aan de hand van de meegegeven ccs nummers.
 */

export function useMaatschappijenGetMaatschappijenByCcsNummers<
  TData = Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<MaatschappijenGetMaatschappijenByCcsNummersParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatschappijenGetMaatschappijenByCcsNummers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatschappijenGetMaatschappijenByCcsNummersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
